import React, { useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import Calendario from "../components/Calendario";
import ButtonLayout from "../components/ButtonLayout";

export default function (props) {
  const [day, setDay] = useState();

  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View style={{ flex: 1, justifyContent: "center" }}>
        <Title style={{ fontFamily: "Nunito-Bold", marginBottom: 10 }}>
          Seleccionar día
        </Title>
        <Calendario
          onChange={(day) => {
            setDay(day);
          }}
          minDate={new Date(Date.now())}
          maxDate={new Date(Date.now()).setDate(
            new Date(Date.now()).getDate() +
              props.route.params.instalaciones.antelacion
          )}
        />
        {day != undefined && (
          <ButtonLayout
            text='Aceptar'
            onPress={() =>
              props.navigation.navigate("Paso3Cita", {
                ...props.route.params,
                day: day,
              })
            }
          />
        )}
      </View>
    </BackgroundUser>
  );
}
